
import { Component, Vue } from 'vue-property-decorator';
import { dayAbbr } from '../util/dateUtils';

@Component({})
export default class WeekTextComponent extends Vue {
  get weekdays(): string[] { return dayAbbr }
}
